// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button } from '@mui/material'
import { find, get } from 'lodash'
import moment from 'moment'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import type { OptionType } from '../../../common/select/Select'
import Select from '../../../common/select/Select'
import { downloadExcelFromBase64 } from '../../../common/utils'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import withActiveStation from '../../station/withActiveStation'
import MonthDisplay from '../MonthDisplay'
import FeelingsMeterAnswersTable from './FeelingMeterAnswersTable'
import FeelingMeterNotesTable from './FeelingMeterNotesTable'
import css from './feelingMeterNotes.css'
import {
  exportFeelingMeterNotes,
  fetchCompaniesList,
  fetchFeelingMeterNotes,
  fetchStationsList,
  fetchStationsOfCompany,
  getAnsweredQuestionsByStationAndDate,
  getAnswersByStationDateAndQuestion,
} from './feelingMeterNotesQueries'

@withActiveStation
@withUser
class FeelingMeterNotes extends React.PureComponent {
  constructor(props) {
    super(props)
    const defaultStation = props.activeStation.id
    this.state = {
      selectedStation: defaultStation,
      selectedCompany: null,
      selectedQuestion: null,
      month: moment(),
    }
  }

  componentDidMount() {
    const { user } = this.props

    if (user.userType !== 'SokAdmin') {
      this.setState({
        selectedCompany: user.company.id,
      })
    }
  }

  onChangeStation = (option: OptionType) => {
    this.setState({
      selectedStation: option.value,
      selectedQuestion: null,
    })
  }
  onChangeMonth = (step: number) => {
    const { month } = this.state
    this.setState({
      month: moment(month).add(step, 'months'),
      selectedQuestion: null,
    })
  }
  onChangeCompany = (option: OptionType) => {
    this.setState({
      selectedCompany: option.value,
      selectedStation: null,
      selectedQuestion: null,
    })
  }
  onChangeQuestion = (option: OptionType) => {
    this.setState({
      selectedQuestion: option.value,
    })
  }
  getStationsList = (companies) => {
    const { selectedCompany } = this.state

    if (selectedCompany) {
      const company = find(companies, {
        id: selectedCompany,
      })
      return get(company, 'stations', [])
    } else {
      return companies.map((c) => get(c, 'stations', [])).flat()
    }
  }
  downloadFile = (data) => {
    const year = moment(this.state.month).year()
    const month = moment(this.state.month).month() + 1
    const fileName = `FIILISMITTARI_PALAUTTEET_${month}_${year}.xlsx`
    downloadExcelFromBase64(fileName, data.exportFeelingMeterNotes)
  }

  render() {
    const { selectedStation, month, selectedCompany, selectedQuestion } = this.state
    const { user } = this.props
    return (
      <div>
        <div className={css.selectorGroup}>
          {user.userType === 'SokAdmin' ? (
            <>
              <Query query={fetchCompaniesList}>
                {({ loading, data, error }) => {
                  const companies = get(data, 'companies', [])
                  const options = [
                    {
                      label: i18n.t('reporting.label.feelingMeterNotes.allCompanies'),
                      value: null,
                    },
                    ...companies.map((c) => ({
                      label: c.name,
                      value: c.id,
                    })),
                  ]
                  return (
                    <div className={css.selector}>
                      <div className={css.selectorLabel}>
                        {i18n.t('reporting.label.feelingMeterNotes.chooseCompany')}
                      </div>
                      <Select options={options} onChange={this.onChangeCompany} value={selectedCompany} />
                    </div>
                  )
                }}
              </Query>
              <Query
                query={selectedCompany ? fetchStationsOfCompany : fetchStationsList}
                variables={{
                  companyId: selectedCompany,
                }}
              >
                {({ loading, data, error }) => {
                  const stations = selectedCompany
                    ? get(data, 'stationsOfCompany.edges', [])
                    : get(data, 'stations.edges', [])
                  const options = [
                    {
                      label: i18n.t('reporting.label.feelingMeterNotes.allStations'),
                      value: null,
                    },
                    ...stations.map((station) => ({
                      label: get(station, 'node.name', '').toUpperCase(),
                      value: get(station, 'node.id', ''),
                    })),
                  ]
                  return (
                    <div className={css.selector}>
                      <div className={css.selectorLabel}>
                        {i18n.t('reporting.label.feelingMeterNotes.chooseStation')}
                      </div>
                      <Select options={options} onChange={this.onChangeStation} value={selectedStation} />
                    </div>
                  )
                }}
              </Query>
            </>
          ) : (
            <Query query={fetchStationsList}>
              {({ loading, data, error }) => {
                const stations = get(data, 'stations.edges', [])
                const options = [
                  {
                    label: i18n.t('reporting.label.feelingMeterNotes.allStations'),
                    value: null,
                  },
                  ...stations.map((station) => ({
                    label: get(station, 'node.name', '').toUpperCase(),
                    value: get(station, 'node.id', ''),
                  })),
                ]
                return (
                  <div className={css.selector}>
                    <div className={css.selectorLabel}>{i18n.t('reporting.label.feelingMeterNotes.chooseStation')}</div>
                    <Select options={options} onChange={this.onChangeStation} value={selectedStation} />
                  </div>
                )
              }}
            </Query>
          )}
          {(user.userType === 'SokAdmin' || user.userType === 'AokAdmin') && (
            <Query
              query={getAnsweredQuestionsByStationAndDate}
              variables={{
                stationId: selectedStation,
                month: +month.format('M'),
                year: +month.format('YYYY'),
              }}
            >
              {({ loading, data, error }) => {
                const items = get(data, 'getAnsweredQuestionsByStationAndDate', [])
                if (items.length === 0) return null
                const questionOptions = items.map((item, index) => {
                  return {
                    label: item.question,
                    value: item.question,
                  }
                })
                const defaultOption = {
                  label: '---',
                  value: null,
                }
                const options = [...[defaultOption], ...questionOptions]
                return (
                  <div className={css.selector}>
                    <div className={css.selectorLabel}>Valitse kysymys</div>
                    <Select options={options} onChange={this.onChangeQuestion} value={selectedQuestion} />
                  </div>
                )
              }}
            </Query>
          )}
        </div>
        <MonthDisplay selectedMonth={month} onMonthChange={this.onChangeMonth} />
        {selectedQuestion !== null && (
          <Query
            query={getAnswersByStationDateAndQuestion}
            variables={{
              stationId: selectedStation,
              question: selectedQuestion,
              month: +month.format('M'),
              year: +month.format('YYYY'),
            }}
          >
            {({ data, loading, error }) => {
              const answers = get(data, 'getAnswersByStationDateAndQuestion', [])
              return <FeelingsMeterAnswersTable answers={answers} question={selectedQuestion} />
            }}
          </Query>
        )}
        {selectedQuestion === null && (
          <Query
            query={fetchFeelingMeterNotes}
            variables={{
              companyId: selectedCompany,
              stationId: selectedStation,
              year: moment(month).year(),
              month: moment(month).month(),
            }}
          >
            {({ data, loading, error }) => {
              const notes = get(data, 'reportFeelingMeterNotes', [])
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  {notes.length > 0 && (
                    <Mutation
                      mutation={exportFeelingMeterNotes}
                      variables={{
                        companyId: selectedCompany,
                        stationId: selectedStation,
                        year: moment(month).year(),
                        month: moment(month).month(),
                      }}
                      onCompleted={(data) => this.downloadFile(data)}
                    >
                      {(onMutate) => (
                        <div className={css.exportButtonContainer}>
                          <Button className={css.exportButton} onClick={onMutate}>
                            {i18n.t('reporting.label.feelingMeterNotes.export')}
                          </Button>
                        </div>
                      )}
                    </Mutation>
                  )}

                  <FeelingMeterNotesTable notes={notes} />
                </Loader>
              )
            }}
          </Query>
        )}
      </div>
    )
  }
}

export default FeelingMeterNotes
